import { useEffect } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { setLocale } from '@app/i18n';

import { PublicBackground } from '@app/core';
import { useIncentiveText, usePublicSession, useRecruitment } from '@app/api';

import { StudyLanding } from './StudyLanding';
import { ApplicationSteps } from './ApplicationSteps';
import { NotInterested } from './NotInterested';
import { TrackApplicationContainer } from './components/TrackApplicationContainer';
import { useTrackingParams } from '@app/analytics';

export const StudyApplication = () => {
  const { id } = useParams<{ id: string }>();
  const { data: session, isLoading: fetching } = usePublicSession(id);

  const { data: recruitment, isLoading: recruitmentLoading } = useRecruitment(
    session?.recruitmentId,
  );

  const incentiveText = useIncentiveText(id, session, undefined);
  const tracking = useTrackingParams();

  const locale = session?.locale;
  useEffect(() => {
    if (!locale) {
      return;
    }
    setLocale(locale);
  }, [locale]);

  const sessionLinkId = !session || id === session.id ? undefined : id;

  if (!session || recruitmentLoading || fetching || !recruitment) {
    return <PublicBackground isLoading={fetching || recruitmentLoading} />;
  }

  return (
    <TrackApplicationContainer
      sessionId={session.id}
      sessionLinkId={sessionLinkId}
    >
      <Routes>
        <Route
          index
          element={
            <StudyLanding
              session={session}
              recruitment={recruitment}
              sessionLinkId={sessionLinkId}
            />
          }
        />
        <Route path="/not-interested" element={<NotInterested />} />
        <Route
          path="*"
          element={
            <ApplicationSteps
              session={session}
              recruitment={recruitment}
              incentiveText={incentiveText}
              sessionLinkId={sessionLinkId}
              trackingId={tracking.tid}
            />
          }
        />
      </Routes>
    </TrackApplicationContainer>
  );
};
